import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import TileButton from '../TileButton'
import ModelViewer from '../../ModelViewer/ModelViewer'

class BuildingListInfo extends React.Component {
  constructor() {
    super()
  }
  callCreateBuilding(building) {
    const { createBuilding, selectedTile } = this.props
    this.closePopup()
    createBuilding(building, selectedTile)
  }

  closePopup() {
    const { removePopup } = this.props
    removePopup('tile_popup')
  }

  displayButton(label, icon, action, disabled = false) {
    return (
      <TileButton
        key={label + '_' + icon}
        label={label}
        icon={icon}
        action={action}
        disabled={disabled}
      />
    )
  }

  render() {
    const { building, buildings, parameters, userData } = this.props

    let b_config = buildings[building.id ? building.id : building.name]
    if (!b_config) {
      return null
    }
    let default_asset = b_config.assets[building.level ? building.level - 1 : 0]
    let building_modifications = parameters[building.id || building.name]
      ? parameters[building.id || building.name].modifications
      : null
    let canPucharse = userData.coins < b_config.pricePerLevel[0] && !building.isFree

    let currentButton = this.displayButton(
      'map.buildings.construct',
      'icon-crane',
      () => this.callCreateBuilding(building),
      canPucharse
    )
    return (
      <ul className="list--panel__submenu">
        <li className="list--panel__submenu--item">
          <span className="title">
            <FormattedMessage id="map.buildings.level" />
            {building.level ? building.level : 1}
          </span>
        </li>
        <li className="list--panel__submenu--item">
          <div className="list--panel__info">
            <div className="column">
              <div className="text">
                <FormattedMessage id="map.buildings.cost" />
              </div>
              <div className="value violet">
                {building.isFree ? 0 : b_config.pricePerLevel[0]}{' '}
                <span className="icon-coin"> </span>
              </div>
            </div>
            <div className="column">
              <div className="text">
                <FormattedMessage id="map.buildings.construction" />
              </div>
              <div className="value">
                {building.isFree ? (
                  <FormattedMessage id="map.buildings.instant" />
                ) : (
                  <FormattedMessage id="map.buildings.one_turn" values={{ turns: 1 }} />
                )}
              </div>
            </div>
          </div>
        </li>
        <li className="list--panel__submenu--item">
          <ModelViewer model={default_asset} customParams={building_modifications} />
        </li>
        <li className="list--panel__item centered">{currentButton}</li>
      </ul>
    )
  }
}

BuildingListInfo.propTypes = {
  removePopup: PropTypes.func,
  building: PropTypes.object,
  buildings: PropTypes.object,
  parameters: PropTypes.object,
  selectedTile: PropTypes.object,
  createBuilding: PropTypes.func,
}

export default BuildingListInfo
